import { Leave, LeaveRecsQuery } from './leaves.model';
import { ActionTypes, LeaveActionTypes } from './leaves.types';

export const leavesRequested = (query: LeaveRecsQuery): ActionTypes => ({
  type: LeaveActionTypes.LeavePageRequested,
  payload: { query },
});

export const leavePageToggleLoading = (isLoading: boolean): ActionTypes => ({
  type: LeaveActionTypes.LeavePageToggleLoading,
  payload: { isLoading },
});

export const leavePageLoaded = ({
  leaveRecords,
  totalCount,
  query,
}: {
  leaveRecords: Leave[];
  totalCount: number;
  query: LeaveRecsQuery;
}): ActionTypes => ({
  type: LeaveActionTypes.LeavePageLoaded,
  payload: { leaveRecords, query, totalCount },
});

// New action creators
export const leaveActionToggleLoading = (isLoading: boolean): ActionTypes => ({
  type: LeaveActionTypes.LeaveActionToggleLoading,
  payload: { isLoading },
});

// Leave Detail
export const leaveDetailRequested = (leaveId: string, callback?: () => void): ActionTypes => ({
  type: LeaveActionTypes.LeaveDetailRequested,
  payload: { leaveId, callback },
});

export const leaveDetailLoaded = (leaveDetail: Leave): ActionTypes => ({
  type: LeaveActionTypes.LeaveDetailLoaded,
  payload: { leaveDetail },
});

// Apply Leave
export const leaveApplyRequested = (
  leaveData: Leave,
  callback?: (responseLeave: Leave) => void
): ActionTypes => ({
  type: LeaveActionTypes.LeaveApplyRequested,
  payload: { leaveData, callback },
});

export const leaveApplySuccess = (): ActionTypes => ({
  type: LeaveActionTypes.LeaveApplySuccess,
});

// Update Leave
export const leaveUpdateRequested = (leaveData: Leave, callback?: () => void): ActionTypes => ({
  type: LeaveActionTypes.LeaveUpdateRequested,
  payload: { leaveData, callback },
});

export const leaveUpdateSuccess = (): ActionTypes => ({
  type: LeaveActionTypes.LeaveUpdateSuccess,
});

// Delete Leave
export const leaveDeleteRequested = (leaveId: string, callback?: () => void): ActionTypes => ({
  type: LeaveActionTypes.LeaveDeleteRequested,
  payload: { leaveId, callback },
});

export const leaveDeleteSuccess = (): ActionTypes => ({
  type: LeaveActionTypes.LeaveDeleteSuccess,
});

// Leave Types
export const leaveTypesRequested = (): ActionTypes => ({
  type: LeaveActionTypes.LeaveTypesRequested,
});

export const leaveTypesLoaded = (leaveTypes: any[]): ActionTypes => ({
  type: LeaveActionTypes.LeaveTypesLoaded,
  payload: { leaveTypes },
});
